<template>
  <div id="section04" class="cd-seciton section">
    <i class="bg left"><img src="@/assets/img/4-1.png" alt="" /></i>
    <i class="bg right"><img src="@/assets/img/4-2.png" alt="" /></i>
    <div class="inner">
      <div class="state--box left">
        <div class="box-head">
          <h5 class="section--title">주요지표그래프</h5>
          <router-link :to="{name: '주요통계지표' }" ><img src="@/assets/img/more.svg" alt="주요통계지표 더보기" title="주요통계지표 더보기" ></router-link>
        </div>
        <div class="swiper-container" id="chart_slide">
          <swiper class="swiper-wrapper" :options="statChartSwiperOption">
            <swiperSlide class="swiper-slide">
              <h5 class="slide--title">
                <span>문화</span>
                <p :title="clsSysNm">{{ clsSysNm }}</p>
                <div>(단위: {{unitNm}})</div>
              </h5>
              <div class="slide--content">
                <VChart class="chart" :option="mainChartLineOptionMh" style="width: 100%; height: 350px;" autoresize></VChart>
              </div>
            </swiperSlide>
            <swiperSlide class="swiper-slide">
              <h5 class="slide--title">
                <span>문화</span>
                <p :title="clsSysNmt">{{ clsSysNmt }}</p>
                <div>(단위: {{unitNmt}})</div>
              </h5>
              <div class="slide--content">
                <VChart class="chart" :option="mainChartBarOptionBy" style="width: 100%; height: 350px;" autoresize></VChart>
              </div>
            </swiperSlide>
            <swiperSlide class="swiper-slide">
              <h5 class="slide--title">
                <span>관광</span>
                <p :title="clsSysNmtr">{{ clsSysNmtr }}</p>
                <div>(단위: {{unitNmtr}})</div>
              </h5>
              <div class="slide--content">
                <VChart class="chart" :option="mainChartBarOptionPa" style="width: 100%; height: 350px;" autoresize></VChart>
              </div>
            </swiperSlide>
            <swiperSlide class="swiper-slide">
              <h5 class="slide--title">
                <span>관광</span>
                <p :title="clsSysNmf">{{ clsSysNmf }}</p>
                <div>(단위: {{unitNmf}})</div>
              </h5>
              <div class="slide--content">
                <VChart class="chart" :option="mainChartBarOptionDt" style="width: 100%; height: 350px;" autoresize></VChart>
              </div>
            </swiperSlide>
            <swiperSlide class="swiper-slide">
              <h5 class="slide--title">
                <span>스포츠</span>
                <p title="스포츠산업 사업체수, 종사자수 현황">스포츠산업 사업체수, 종사자수 현황</p>
                <div>(단위: 개,천명)</div>
              </h5>
              <div class="slide--content">
                <VChart class="chart" :option="mainChartLineOptionSio" style="width: 100%; height: 350px;" autoresize></VChart>
              </div>
            </swiperSlide>
            <swiperSlide class="swiper-slide">
              <h5 class="slide--title">
                <span>스포츠</span>
                <p title="스포츠산업 매출액 현황">스포츠산업 매출액 현황</p>
                <div>(단위: 십억원)</div>
              </h5>
              <div class="slide--content">
                <VChart class="chart" :option="mainChartLineOptionSit" style="width: 100%; height: 350px;" autoresize></VChart>
              </div>
            </swiperSlide>
            <swiperSlide class="swiper-slide">
              <h5 class="slide--title">
                <span>스포츠</span>
                <p title="20년전 대비 20대초반의 신장, 체중 변화">20년전 대비 20대초반의 신장, 체중 변화</p>
                <div>(단위: cm, kg)</div>
              </h5>
              <div class="slide--content">
                <VChart class="chart" :option="mainChartBarOptionPs" style="width: 100%; height: 350px;" autoresize></VChart>
              </div>
            </swiperSlide>
          </swiper>
          <div class="swiper-option">
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>
      </div>
      <div class="state--box right">
        <div class="box-head">
          <h5 class="section--title">SNS분석 서비스</h5>
          <router-link :to="{name: 'SNS분석' }" ><img src="@/assets/img/more.svg" alt="SNS분석 더보기" title="SNS분석 더보기" ></router-link>
        </div>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <MainWordCloud ref="refWordCloud" :searchParams="searchParams" ></MainWordCloud>
            </div>
          </div>
          <div class="swiper-option">
            <span style="font-weight:500;color:#666;">※ 최근 1개월 기준</span>
            <select name="keyword" id="keyword" v-model="keyword">
                <option value="문화">문화</option>
                <option value="체육">체육</option>
                <option value="관광">관광</option>
            </select>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import CommonUtil from '@/assets/js/commonUtil'
import MainWordCloud from './MainWordCloud'
import VChart from 'vue-echarts'
import * as api from '@/api/StatCharts.js'
import chartOption from '@/assets/js/chartOption'

export default {
	name: 'MainContents04',
	components: {
		swiper,
		swiperSlide,
		MainWordCloud,
		VChart
	},

	data () {
		return {
			// 주요통계지표 슬라이드 옵션
			statChartSwiperOption: {
				slidesPerView: 1, // 레이아웃 뷰 개수
				watchSlidesProgress: true,
				navigation: { // 버튼
					nextEl: '#chart_slide .swiper-button-next',
					prevEl: '#chart_slide .swiper-button-prev'
				}
			},
			mainChartLineOptionMh: {},
			mainChartBarOptionBy: {},
			mainChartBarOptionPa: {},
			mainChartBarOptionDt: {},
			mainChartLineOptionSio: {},
			mainChartLineOptionSit: {},
			mainChartBarOptionPs: {},
			mainChartBarOptionPs2: {},
			clsSysNm: '',
			clsSysNmt: '',
			clsSysNmtr: '',
			clsSysNmf: '',
			unitNm: '',
			unitNmt: '',
			unitNmtr: '',
			unitNmf: '',
			// sns분석
			keyword: '문화',
			startDate: '',
			endDate: '',
			channels: ['', '10', '20', '30'],
			searchParams: {},
			resizeTo: 0,

			searchCount: 70,
			wordCloudIdx: '1',
			maskImage: new Image(),
			wordCloudData: [],
			option: {
				series: [{
					type: 'wordCloud',
					left: 'center',
					top: 'center',
					width: '100%',
					height: '100%',
					sizeRange: [20, 130],
					rotationRange: [0, 0],
					rotationStep: 20,
					gridSize: 0,
					shape: 'circle',
					maskImage: this.maskImage,
					drawOutOfBound: false,
					layoutAnimation: true,
					data: []
				}]
			}
		}
	},

	watch: {
		keyword: function () {
			this.searchSnsData()
		}
	},

	mounted () {
		window.addEventListener('resize', this.eventViewResize)
		this.searchSnsData()
	},

	created () {
		this.initView()
		this.mhChart1()
		this.mhChart2()
		this.mhChart3()
		this.mhChart4()
		this.mhChart5()
		this.mhChart6()
		this.mhChart7()
	},

	destroyed () {
		window.removeEventListener('resize', this.eventViewResize)
	},

	methods: {
		// 화면 초기화 및 기초 데이터 설정
		initView () {
			const toDay = new Date()

			const searchEndBaseDate = new Date()
			searchEndBaseDate.setDate(toDay.getDate() - 1)
			const searchStartBaseDate = new Date()
			searchStartBaseDate.setDate(toDay.getDate() - 1)
			searchStartBaseDate.setMonth(toDay.getMonth() - 1)

			this.startDate = CommonUtil.getFormatDate(searchStartBaseDate, '-')
			this.endDate = CommonUtil.getFormatDate(searchEndBaseDate, '-')
			// 데이터 적재가 되지 않아서 일단 고정
			// this.startDate = '20231004'
			// this.endDate = '20231010'
		},

		async mhChart1 () { // 문화예술행사 관람률 변화 추이
			const upClsSysNo = 'DATA-000044'
			let titleRowData = {}

			const titleData = await api.searchChartTitleData({ upClsSysNo: upClsSysNo, mainGubun: 'Y' })

			if (titleData) {
				if (titleData.data && titleData.data.nameData.length > 0) {
					titleRowData = titleData.data.nameData[0]
				}
			}

			if (titleRowData) {
				this.clsSysNm = titleRowData.clsSysNm
				this.unitNm = titleRowData.unitNm
			}

			const paramData = {
				clsSysNo: titleRowData.clsSysNo,
				entityId: titleRowData.entityId
			}

			const resultData = await api.searchChartData(paramData) // 차트의 이름&수치 데이터 조회
			this.mainChartLineOptionMh = chartOption.mainLineChart() // chartOption.js에서 차트의 틀을 불러와서 그래프1차트 만들기
			this.mainChartLineOptionMh.toolbox.show = false // toolbox 숨김
			this.mainChartLineOptionMh.grid.top = '4%'

			var xAxisYearList = [] // 연도 데이터 리스트

			if (resultData) {
				for (let i = 0; i < resultData.data.nameData.length; i++) {
					const chartS = { // 데이터틀 담는 부분
						name: '',
						type: 'line',
						areaStyle: {},
						barWidth: '10%',
						label: {
							show: true,
							position: 'top',
							formatter: function (p) {
								return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
							}
						},
						data: []
					}
					chartS.name = resultData.data.nameData[i].attrNm // 차트 데이터의 이름+legned 이름 지정

					var chartDataList = []

					for (let j = 0; j < resultData.data.seriesData.length; j++) { // 7개
						chartDataList.push(resultData.data.seriesData[j]['dataCtnt' + (i + 1)])

						var year = resultData.data.seriesData[j].creTme // 차트의 연도 데이터 가져오기

						if (!xAxisYearList.includes(year)) {
							xAxisYearList.push(year)
						}
					}
					chartS.data = chartDataList

					this.mainChartLineOptionMh.xAxis[0].data = xAxisYearList
					this.mainChartLineOptionMh.series.push(chartS)
				}
				// this.mainChartBarGgBOption.title.text = '관광산업별 사업체수'
			}
		},

		async mhChart2 () { // 분야별 문화행사 관람율
			const upClsSysNo = 'DATA-000044'
			let titleRowData = {}

			const titleData = await api.searchChartTitleData({ upClsSysNo: upClsSysNo, mainGubun: 'Y' })

			if (titleData) {
				if (titleData.data && titleData.data.nameData.length > 0) {
					titleRowData = titleData.data.nameData[1]
				}
			}

			if (titleRowData) {
				this.clsSysNmt = titleRowData.clsSysNm
				this.unitNmt = titleRowData.unitNm
			}

			const paramData = {
				clsSysNo: titleRowData.clsSysNo,
				entityId: titleRowData.entityId
			}

			const resultData = await api.searchChartData(paramData)
			this.mainChartBarOptionBy = chartOption.mainBarChartmh()
			this.mainChartBarOptionBy.toolbox.show = false // toolbox 숨김
			this.mainChartBarOptionBy.grid.top = '4%'
			// mainBarChartmh는 x축 label휘어짐, 위에 아이콘때문에 새로 만든거구 변경없으면 barchart하나로 같이 사용가능

			var xAxisData = [] // x축 데이터 (항목명 nameData)
			var yAxisData = [] // y축 데이터 (수치,년도 seriesData)

			if (resultData) {
				// x축 데이터 설정
				for (let i = 0; i < resultData.data.nameData.length; i++) { // 9개
					xAxisData.push(resultData.data.nameData[i].attrNm)
				}
				// y축 데이터 설정
				for (let j = 0; j < resultData.data.seriesData.length; j++) { // 4개
					const chartS = {
						// name: resultData.data.seriesData[j]['attrNm'], // seriesData의 이름 설정
						type: 'bar',
						barWidth: '10%',
						label: {
							show: true,
							position: 'top',
							formatter: function (p) {
								return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
							}
						},
						data: [] // 수치 값 배열
					}
					chartS.name = resultData.data.seriesData[j].creTme // 차트 데이터의 이름 연도로 지정

					for (let i = 0; i < resultData.data.nameData.length; i++) { // 수치데이터
						chartS.data.push(resultData.data.seriesData[j]['dataCtnt' + (i + 1)])
					}

					yAxisData.push(chartS)// 수치, 년도값
				}

				// x축 및 y축 데이터 설정
				this.mainChartBarOptionBy.xAxis[0].data = xAxisData
				this.mainChartBarOptionBy.series = yAxisData
			}
		},

		async  mhChart3 () { // 여행지출액 총량
			const upClsSysNo = 'DATA-000045'
			let titleRowData = {}

			const titleData = await api.searchChartTitleData({ upClsSysNo: upClsSysNo, mainGubun: 'Y' })

			if (titleData) {
				if (titleData.data && titleData.data.nameData.length > 0) {
					titleRowData = titleData.data.nameData[0]
				}
			}
			if (titleRowData) {
				this.clsSysNmtr = titleRowData.clsSysNm
				this.unitNmtr = titleRowData.unitNm
			}

			const paramData = {
				clsSysNo: titleRowData.clsSysNo,
				entityId: titleRowData.entityId
			}

			const resultData = await api.searchChartData(paramData)
			this.mainChartBarOptionPa = chartOption.mainBarChartGg()
			this.mainChartBarOptionPa.toolbox.show = false // toolbox 숨김
			this.mainChartBarOptionPa.grid.top = '4%'

			var xAxisData = [] // x축 데이터 (nameData, 전체/숙박/당일 )
			var yAxisData = [] // y축 데이터 (년도 seriesData)

			if (resultData) {
				// x축 데이터 설정
				for (let i = 0; i < resultData.data.nameData.length; i++) { // 3개
					xAxisData.push(resultData.data.nameData[i].attrNm)
				}
				// y축 데이터 설정
				for (let j = 0; j < resultData.data.seriesData.length; j++) { // 4개
					const chartS = {
						// name: resultData.data.seriesData[j]['attrNm'], // seriesData의 이름 설정
						type: 'bar',
						barWidth: '15%',
						label: {
							show: true,
							position: 'top',
							formatter: function (p) {
								return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
							}
						},
						data: [] // 수치 값 배열
					}
					chartS.name = resultData.data.seriesData[j].creTme // 차트 데이터의 이름 연도로 지정

					for (let i = 0; i < resultData.data.nameData.length; i++) {
						chartS.data.push(resultData.data.seriesData[j]['dataCtnt' + (i + 1)])
					}
					yAxisData.push(chartS)
				}
				// x축 및 y축 데이터 설정
				this.mainChartBarOptionPa.xAxis[0].data = xAxisData
				this.mainChartBarOptionPa.series = yAxisData
			}
		},

		async  mhChart4 () { // 국내여행
			const upClsSysNo = 'DATA-000045'
			let titleRowData = {}

			const titleData = await api.searchChartTitleData({ upClsSysNo: upClsSysNo, mainGubun: 'Y' })

			if (titleData) {
				if (titleData.data && titleData.data.nameData.length > 0) {
					titleRowData = titleData.data.nameData[1]
				}
			}
			if (titleRowData) {
				this.clsSysNmf = titleRowData.clsSysNm
				this.unitNmf = titleRowData.unitNm
			}

			const paramData = {
				clsSysNo: titleRowData.clsSysNo,
				entityId: titleRowData.entityId
			}

			const resultData = await api.searchChartData(paramData)
			this.mainChartBarOptionDt = chartOption.mainBarChartGg()
			this.mainChartBarOptionDt.toolbox.show = false // toolbox 숨김
			this.mainChartBarOptionDt.grid.top = '4%'

			var xAxisData = [] // x축 데이터 (항목명 nameData)
			var yAxisData = [] // y축 데이터 (년도 seriesData)

			if (resultData) {
				// x축 데이터 설정
				for (let i = 0; i < resultData.data.nameData.length; i++) {
					xAxisData.push(resultData.data.nameData[i].attrNm)
				}
				// y축 데이터 설정
				for (let j = 0; j < resultData.data.seriesData.length; j++) {
					const chartS = {
						// name: resultData.data.seriesData[j]['attrNm'], // seriesData의 이름 설정
						type: 'bar',
						barWidth: '15%',
						label: {
							show: true,
							position: 'top',
							formatter: function (p) {
								return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
							}
						},
						data: [] // 수치 값 배열
					}
					chartS.name = resultData.data.seriesData[j].creTme // 차트 데이터의 이름 지정

					for (let i = 0; i < resultData.data.nameData.length; i++) {
						chartS.data.push(resultData.data.seriesData[j]['dataCtnt' + (i + 1)])
					}
					yAxisData.push(chartS)
				}
				// x축 및 y축 데이터 설정
				this.mainChartBarOptionDt.xAxis[0].data = xAxisData
				this.mainChartBarOptionDt.series = yAxisData
			}
		},

		async chartType (resultData, chartIndex) { // 스포츠 산업조사1 통합
			this.mainChartLineOptionSio = chartOption.mainLineBarChart()

			const resultNameData = resultData.data.nameData
			const resultSeriesData = resultData.data.seriesData

			const nameData = []
			const seriesData = resultSeriesData

			for (let i = 0; i < resultNameData.length; i++) { // 3번
				if (i === 1) {
					continue // nameData[1] 제외
				}
				nameData.push(resultNameData[i]) // 2개
			}

			const xAxis = []
			const legendData = []
			const chartSeries = []
			const xAxisData = []

			for (let i = 0; i < nameData.length; i++) { // 2번
				legendData.push(nameData[i].attrNm)// label값 nameData로 지정

				const series = {
					name: legendData[i],
					type: i === 0 ? 'bar' : 'line',
					yAxisIndex: i === 1 ? 1 : 0,
					barWidth: '20%',
					emphasis: {
						focus: 'series'
					},
					label: {
						show: true,
						position: 'top',
						formatter: function (p) {
							return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
						}
					},
					data: []
				}
				chartSeries.push(series)
			}

			const datas1 = []// 사업체
			const datas2 = []// 종사자

			const seriesList = chartSeries[0]
			const seriesListT = chartSeries[1]

			for (let sIdx = 0; sIdx < seriesData.length; sIdx++) { // 연도 기준 + 한 그래프에 그릴수 있는 데이터 갯수 결정
				xAxisData.push(seriesData[sIdx].creTme)

				datas1.push({
					name: legendData[0], // datas1 데이터 포인트의 레전드 이름을 설정
					value: seriesData[sIdx]['dataCtnt' + (chartIndex * 2 + 1)]// 사업체수
				})
				datas2.push({
					name: legendData[1], // datas2 데이터 포인트의 레전드 이름을 설정
					value: seriesData[sIdx]['dataCtnt' + (chartIndex * 2 + 3)]// 종사자수
				})
			}
			seriesList.data = datas1
			seriesListT.data = datas2

			xAxis.push(
				{
					type: 'category',
					data: xAxisData
				}
			)

			this.mainChartLineOptionSio.legend.data = legendData
			this.mainChartLineOptionSio.xAxis = xAxis
			this.mainChartLineOptionSio.series = chartSeries
			this.mainChartLineOptionSio.toolbox.show = false // toolbox 숨김
			this.mainChartLineOptionSio.grid.top = '4%'
		},

		async mhChart5 () { // 스포츠산업 사업체수,종사자수 현황
			const paramData = {
				clsSysNo: 'DATA-000075',
				// entityId: 'ENTT-000085', //개발
				entityId: 'ENTT-000086' // 운영

			}
			const resultData = await api.searchChartData(paramData)
			this.chartType(resultData, 0)
		},

		async mhChart6 () { // 스포츠산업 매출액 현황
			const paramData = {
				clsSysNo: 'DATA-000075',
				// entityId: 'ENTT-000085', //개발
				entityId: 'ENTT-000086' // 운영
			}

			const resultData = await api.searchChartData(paramData)
			this.mainChartLineOptionSit = chartOption.mainLineChart()

			var xAxisYearList = [] // 연도 데이터 리스트

			if (resultData) {
				const dataIndex = 1
				for (let i = 0; i < resultData.data.nameData.length; i++) {
					if (i !== dataIndex) {
						continue
					}
					const chartS = { // 데이터틀 담는 부분
						name: '',
						type: 'line',
						areaStyle: {},
						barWidth: '10%',
						label: {
							show: true,
							position: 'top',
							formatter: function (p) {
								return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
							}
						},
						data: []
					}
					chartS.name = resultData.data.nameData[i].attrNm // 차트 데이터의 이름 지정

					var chartDataList = [] // 수치 값 배열방에 넣어주기

					for (let j = 0; j < resultData.data.seriesData.length; j++) { // 차트 수치 for문
						chartDataList.push(resultData.data.seriesData[j]['dataCtnt' + (i + 1)])
						var year = resultData.data.seriesData[j].creTme // 차트의 연도 데이터 가져오기

						if (!xAxisYearList.includes(year)) {
							xAxisYearList.push(year)
						}
					}
					chartS.data = chartDataList

					this.mainChartLineOptionSit.xAxis[0].data = xAxisYearList
					this.mainChartLineOptionSit.series.push(chartS)
					this.mainChartLineOptionSit.toolbox.show = false // toolbox 숨김
					this.mainChartLineOptionSit.grid.top = '4%'
				}
			}
		},

		async mhChart7 () { // 20년전 대비 20대초반의 신장, 체중 변화
			const paramData1 = {
				clsSysNo: 'DATA-000077',
				entityId: 'ENTT-000087'
			}
			const paramData2 = {
				clsSysNo: 'DATA-000077',
				entityId: 'ENTT-000088'
			}
			const paramData3 = {
				clsSysNo: 'DATA-000078',
				entityId: 'ENTT-000089'
			}
			const paramData4 = {
				clsSysNo: 'DATA-000078',
				entityId: 'ENTT-000090'
			}
			const resultData1 = await api.searchChartData(paramData1)
			const resultData2 = await api.searchChartData(paramData2)

			const resultData3 = await api.searchChartData(paramData3)
			const resultData4 = await api.searchChartData(paramData4)

			this.CharTypePso(resultData1, resultData2, resultData3, resultData4)
		},

		async CharTypePso (resultData1, resultData2, resultData3, resultData4) { // 20년전 대비 20대초반의 신장, 체중 변화
			this.mainChartBarOptionPs = chartOption.mainBarChartSi()

			const resultNameData1 = resultData1.data.nameData // 1
			const resultSeriesData1 = resultData1.data.seriesData // 2

			// const resultNameData2 = resultData2.data.nameData;
			const resultSeriesData2 = resultData2.data.seriesData

			const resultNameData3 = resultData3.data.nameData
			const resultSeriesData3 = resultData3.data.seriesData

			// const resultNameData4 = resultData4.data.nameData;
			const resultSeriesData4 = resultData4.data.seriesData

			const nameData = [] // x축 데이터
			const nameData3 = [] // x축 데이터

			const seriesData1 = resultSeriesData1 // 년도, 수치 (데이터1)
			const seriesData2 = resultSeriesData2 // 년도, 수치 (데이터2)
			const seriesData3 = resultSeriesData3 // 년도, 수치 (데이터3)
			const seriesData4 = resultSeriesData4 // 년도, 수치 (데이터3)

			for (let i = 0; i < resultNameData1.length; i++) {
				nameData.push(resultNameData1[i].attrNm) // 배열에 이름만 추가
			}

			for (let i = 0; i < resultNameData3.length; i++) {
				nameData3.push(resultNameData3[i].attrNm) // 배열에 이름만 추가
			}

			const xAxis = []
			const legendData = []
			const chartSeries = []
			const xAxisData = []

			// y축
			for (let i = 0; i < nameData.length; i++) {
				legendData.push(nameData[i] + ' (남자)') // 남자와 여자 구분하여 추가
				legendData.push(nameData[i] + ' (여자)')
				legendData.push(nameData3[i] + ' (남자)')
				legendData.push(nameData3[i] + ' (여자)')

				const series1 = {
					name: legendData[i * 4],
					type: 'bar',
					barWidth: '10%',
					yAxisIndex: 0,
					emphasis: {
						focus: 'series'
					},
					label: {
						show: true,
						position: 'top',
						formatter: function (p) {
							return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
						}
					},
					data: []
				}

				const series2 = {
					name: legendData[i * 4 + 1],
					type: 'bar',
					barWidth: '10%',
					emphasis: {
						focus: 'series'
					},
					label: {
						show: true,
						position: 'top',
						formatter: function (p) {
							return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
						}
					},
					data: []
				}

				const series3 = {
					name: legendData[i * 4 + 2],
					type: 'line',
					barWidth: '10%',
					yAxisIndex: legendData[i] === 2 | 3 ? 1 : 0,
					emphasis: {
						focus: 'series'
					},
					label: {
						show: true,
						position: 'top',
						formatter: function (p) {
							return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
						}
					},
					data: []
				}

				const series4 = {
					name: legendData[i * 4 + 3],
					type: 'line',
					barWidth: '10%',
					yAxisIndex: legendData[i] === 2 | 3 ? 1 : 0,
					emphasis: {
						focus: 'series'
					},
					label: {
						show: true,
						position: 'top',
						formatter: function (p) {
							return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
						}
					},
					data: []
				}

				chartSeries.push(series1)
				chartSeries.push(series2)
				chartSeries.push(series3)
				chartSeries.push(series4)
			}

			const datas1 = []
			const datas2 = []
			const datas3 = []
			const datas4 = []

			for (let sIdx = 0; sIdx < seriesData1.length; sIdx++) { // 1번
				xAxisData.push(seriesData1[sIdx].creTme)
				for (let i = 0; i < nameData.length; i++) { // 각 년도에 아래 수치 한번씩만 찍어냄
					datas1.push({
						value: seriesData1[sIdx]['dataCtnt' + (i + 1)]
					})
					datas2.push({
						value: seriesData2[sIdx]['dataCtnt' + (i + 1)]
					})
					datas3.push({
						value: seriesData3[sIdx]['dataCtnt' + (i + 1)]
					})
					datas4.push({
						value: seriesData4[sIdx]['dataCtnt' + (i + 1)]
					})
				}
			}

			for (let i = 0; i < chartSeries.length; i++) {
				if (i % 4 === 0) {
					chartSeries[i].type = 'bar'
					chartSeries[i].data = datas1
				} else if (i % 4 === 1) {
					chartSeries[i].type = 'bar'
					chartSeries[i].data = datas2
				} else if (i % 4 === 2) {
					chartSeries[i].type = 'line'
					chartSeries[i].data = datas3
				} else {
					chartSeries[i].type = 'line'
					chartSeries[i].data = datas4
				}
			}
			xAxis.push({
				type: 'category',
				data: xAxisData
			})

			this.mainChartBarOptionPs.legend.data = legendData
			this.mainChartBarOptionPs.xAxis = xAxis
			this.mainChartBarOptionPs.series = chartSeries
			this.mainChartBarOptionPs.toolbox.show = false // toolbox 숨김
			this.mainChartBarOptionPs.grid.top = '4%'
		},

		// this.mainChartBarOptionPs.toolbox.show = false // toolbox 숨김
		// this.mainChartBarOptionPs.grid.top = '4%'

		// 화면 리사이즈 이벤트 (워드클라우드 리사이즈 호출)
		eventViewResize () {
			if (this.resizeTo) {
				clearTimeout(this.resizeTo)
			}
			this.resizeTo = setTimeout(this.$refs.refWordCloud.chartResize, 500)
		},

		// SNS분석 데이터 조회
		searchSnsData () {
			let searchChannel = this.channels.sort().join(',')
			if (searchChannel.indexOf(',') == 0) {
				searchChannel = searchChannel.substring(1)
			}

			this.searchParams = {
				keyword: this.keyword,
				startDate: CommonUtil.replaceAll(this.startDate, '-', ''),
				endDate: CommonUtil.replaceAll(this.endDate, '-', ''),
				channels: searchChannel,
				chnlCd: searchChannel,
				recentStartDate: CommonUtil.addMonthDate(CommonUtil.replaceAll(this.endDate, '-', ''), -2, ''),
				rowCount: 70,
				useExcludeKeyword: 'Y',
				useExcludeSearchKeyword: 'Y'
			}
		}

	}

}
</script>

<style scoped>

</style>
